import { Popover } from 'bootstrap';

/** 
 * Popover
 */
export function initPopover(elem) {
    const popoverTriggerList = [].slice.call(elem.querySelectorAll('[data-bs-toggle="popover"]'));
    popoverTriggerList.map(popoverTriggerEl => {
        let options = {
            delay: {show: 50, hide: 50},
            html: popoverTriggerEl.getAttribute('data-bs-html') === "true" ?? false,
            placement: popoverTriggerEl.getAttribute('data-bs-placement') ?? 'auto'
        };
        return new Popover(popoverTriggerEl, options);
    });
}
initPopover(document);
